import { ChangeEvent, FC, useState } from 'react';

import { createEmptyClientContact } from '../../pages/Clients/components/FormModal/hooks/useClientFormModalContext';
import { useCreateClientContact } from '../../pages/Clients/hooks/useCreateClientContact';
import ClientContactForm from '../ClientContactForm';
import locales from './locales';

interface AddClientContactModalProps {
  clientId: string;
  onBack: () => void;
  onAdd: (contactClientId: string) => void;
}

const AddClientContactModal: FC<AddClientContactModalProps> = ({
  clientId,
  onAdd,
  onBack,
}) => {
  const [clientContact, setClientContact] = useState(createEmptyClientContact);

  const { createClientContact, loading } = useCreateClientContact(clientId);

  const onChange = (e: ChangeEvent<HTMLInputElement>) =>
    setClientContact({
      ...clientContact,
      [e.target?.name]: e.target?.value,
    });

  const onSubmit = async () => {
    const { data } = await createClientContact(clientContact);
    const newClientContact = data?.createClientContact.clientContact;

    if (newClientContact) {
      onAdd(newClientContact.clientContactId);
    }
  };

  return (
    <ClientContactForm
      clientContact={clientContact}
      loading={loading}
      modalTitle={locales.modalTitle}
      onChange={onChange}
      onHeaderBack={onBack}
      onSubmit={onSubmit}
      submitButtonText={locales.submit}
    />
  );
};

export default AddClientContactModal;
